import { ReactNode } from 'react';

import { ComposeConversationTitle } from '@web/conversations/ComposeConversation/ComposeConversationHeader/ComposeConversationTitle';
import { ComposeConversationSubtitle } from '@web/conversations/ComposeConversation/ComposeConversationHeader/ComposeConversationSubtitle';

import { HeaderWrapper, HeaderWrapperWithPadding } from './composeConversationHeader.styles';

type Props = {
  children: ReactNode;
};

export const ComposeConversationHeader = ({ children }: Props) => (
  <HeaderWrapper>{children}</HeaderWrapper>
);

export const ComposeConversationHeaderWithPadding = ({ children }: Props) => (
  <HeaderWrapperWithPadding>{children}</HeaderWrapperWithPadding>
);

ComposeConversationHeader.Title = ComposeConversationTitle;
ComposeConversationHeader.Subtitle = ComposeConversationSubtitle;

ComposeConversationHeaderWithPadding.Title = ComposeConversationTitle;
ComposeConversationHeaderWithPadding.Subtitle = ComposeConversationSubtitle;
